import { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from 'context/AuthContext';

const SOCKET_URL = '';

export default function useSocket(events = {}) {
  const { token } = useAuth();
  const socketRef = useRef(null);
  const [connected, setConnected] = useState(false);
  const eventsRef = useRef(events);
  eventsRef.current = events;

  useEffect(() => {
    if (!token) return;

    const socket = io(SOCKET_URL, {
      auth: { token },
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 2000,
      reconnectionDelayMax: 10000,
    });

    socketRef.current = socket;

    socket.on('connect', () => setConnected(true));
    socket.on('disconnect', () => setConnected(false));

    // Register event listeners
    const eventNames = ['incident:nouveau', 'alerte:nouvelle', 'agent:statut', 'ronde:update', 'notification:nouvelle'];
    eventNames.forEach(name => {
      socket.on(name, (data) => {
        if (eventsRef.current[name]) eventsRef.current[name](data);
      });
    });

    return () => {
      socket.disconnect();
      socketRef.current = null;
    };
  }, [token]);

  return { connected, socket: socketRef.current };
}

// Sound generator using Web Audio API
const audioCtxRef = { current: null };

function getAudioCtx() {
  if (!audioCtxRef.current) audioCtxRef.current = new (window.AudioContext || window.webkitAudioContext)();
  return audioCtxRef.current;
}

function playBeep(freq, duration, repeat = 1, gap = 150) {
  const ctx = getAudioCtx();
  let t = ctx.currentTime;
  for (let i = 0; i < repeat; i++) {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.frequency.value = freq;
    osc.type = 'sine';
    gain.gain.setValueAtTime(0.3, t);
    gain.gain.exponentialRampToValueAtTime(0.001, t + duration);
    osc.start(t);
    osc.stop(t + duration);
    t += duration + gap / 1000;
  }
}

export function playAlertSound(type) {
  const volume = parseInt(localStorage.getItem('gss-alert-volume') || '80', 10);
  if (volume === 0) return;
  if (localStorage.getItem('gss-alerts-muted') === 'true') return;

  switch (type) {
    case 'critique':
      playBeep(880, 0.2, 3, 150);
      break;
    case 'eleve':
      playBeep(660, 0.2, 2, 200);
      break;
    case 'moyen':
      playBeep(440, 0.3, 1);
      break;
    case 'info':
    default:
      playBeep(330, 0.1, 1);
      break;
  }
}
